/* eslint-disable react/prop-types */
import { Box, Grid, Typography } from "@mui/material";
import FormField from "components/FormField";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Form, Formik } from "formik";
import React from "react";
import TaxPersonalTable from "./components/table";
import initialValues from "./schema/initialValues";
import validation from "./schema/validations";
import form from "./schema/form";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";
import Loading from "components/Common/Loading";
import DatepickerField from "components/DatepickerField";
import SwitchField from "components/SwitchField";
import Tabs from "./components/tabs";
import Actions from "./components/actions";
import ModalCommon from "components/Modal";
import ModalContent from "./components/modalContent";
import Fields2 from "./components/field2";
import form2 from "./schema/form2";
import initialValues2 from "./schema/initialValues2";
import validation2 from "./schema/validations2";
import Table2 from "./components/table2";
import Fields3 from "./components/field3";
import form3 from "./schema/form3";
import initialValues3 from "./schema/initialValues3";
import validation3 from "./schema/validations3";
import Table3 from "./components/table3";
import SelectField from "components/SelectField";

export default function FinancialReport23() {
  const { formId, formField } = form;
  const { formId2, formField2 } = form2;
  const { formId3, formField3 } = form3;

  const [open, setOpen] = React.useState(true);
  const [tab, setTab] = React.useState(0);
  const [pickAll, setPickAll] = React.useState(false);

  const [list, setList] = React.useState([
    { name: "BCKQHĐ", checked: false },
    { name: "CDTK", checked: false },
  ]);

  const handleSubmit = async (values, action) => {
    console.log({ values });
  };

  const handleChangeSwitch = (name, checked) => {
    if (pickAll) return;
    setList((prev) =>
      prev.map((item) => {
        if (item.name === name) {
          return { ...item, checked };
        }
        return item;
      })
    );
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {!open && (
        <>
          <Tabs tab={tab} setTab={setTab} list={list} pickAll={pickAll} />
          <Actions
            list={list}
            pickAll={pickAll}
            setPickAll={setPickAll}
            handleChangeSwitch={handleChangeSwitch}
          />
        </>
      )}
      <ModalCommon
        open={open}
        setOpen={setOpen}
        content={
          <ModalContent
            list={list}
            setList={setList}
            pickAll={pickAll}
            setPickAll={setPickAll}
            handleChangeSwitch={handleChangeSwitch}
          />
        }
      >
        {tab === 0 && (
          <Box display="flex" flexDirection="column" pb={10} gap={3}>
            <Box textAlign="center">
              <Typography variant="h4" textTransform="uppercase">
                Báo cáo tình hình tài chính (Mẫu B01a-DNN)
              </Typography>
              <Typography variant="subtitle1" fontStyle="italic" fontSize={14}>
                (Ban hành theo thông tư số 133/2016/TT-BTC ngày 26/8/2016 của Bộ Tài Chính)
              </Typography>
              <Typography variant="subtitle1" fontStyle="italic" fontSize={14}>
                Tại ngày 31 tháng 12 năm 2022
              </Typography>
            </Box>
            <Formik
              initialValues={initialValues}
              validationSchema={validation}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formId} autoComplete="off">
                  <Fields
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                  />
                  <TaxPersonalTable
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                    setFieldValue={setFieldValue}
                  />
                  <SoftBox display="flex" justifyContent="flex-end" gap={3}>
                    <SoftButton
                      disabled={isSubmitting}
                      type="submit"
                      variant="gradient"
                      color="dark"
                    >
                      {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                    </SoftButton>
                  </SoftBox>
                </Form>
              )}
            </Formik>
          </Box>
        )}
        {tab === 1 && (
          <Box display="flex" flexDirection="column" pb={10} gap={3}>
            <Box textAlign="center">
              <Typography variant="h4" textTransform="uppercase">
                Báo cáo kết quả hoạt động kinh doanh
              </Typography>
              <Typography variant="subtitle1" fontStyle="italic" fontSize={14}>
                (Ban hành theo Thông tư số 133/2016/TT-BTC ngày 26/8/2016 của Bộ Tài Chính)
              </Typography>
              <Typography variant="subtitle1" fontSize={14}>
                Năm 2022
              </Typography>
            </Box>
            <Formik
              initialValues={initialValues2}
              validationSchema={validation2}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formId2} autoComplete="off">
                  <Fields2
                    formData={{
                      values,
                      touched,
                      formField2,
                      errors,
                    }}
                  />
                  <Table2 setFieldValue={setFieldValue} />
                  <SoftBox display="flex" justifyContent="flex-end" gap={3} mt={1}>
                    <SoftButton
                      disabled={isSubmitting}
                      type="submit"
                      variant="gradient"
                      color="dark"
                    >
                      {isSubmitting ? <Loading width={25} height={25} /> : "Lưu"}
                    </SoftButton>
                  </SoftBox>
                </Form>
              )}
            </Formik>
          </Box>
        )}
        {tab === 2 && (
          <Box display="flex" flexDirection="column" pb={10} gap={3}>
            <Box textAlign="center">
              <Typography variant="h4" textTransform="uppercase">
                Bảng cân đối tài khoản
              </Typography>
              <Typography variant="subtitle1" fontStyle="italic" fontSize={14}>
                (Ban hành kèm theo Thông tư số 133/2016/TT-BTC ngày 26/8/2016 của Bộ Tài Chính)
              </Typography>
              <Typography variant="subtitle1" fontStyle="italic" fontSize={14}>
                Năm 2022
              </Typography>
            </Box>
            <Formik
              initialValues={initialValues3}
              validationSchema={validation3}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formId3} autoComplete="off">
                  <Fields3
                    formData={{
                      values,
                      touched,
                      formField3,
                      errors,
                    }}
                  />
                  <Table3 setFieldValue={setFieldValue} />
                  <SoftBox display="flex" justifyContent="flex-end" gap={3} mt={1}>
                    <SoftButton
                      disabled={isSubmitting}
                      type="submit"
                      variant="gradient"
                      color="dark"
                    >
                      {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                    </SoftButton>
                  </SoftBox>
                </Form>
              )}
            </Formik>
          </Box>
        )}
      </ModalCommon>
    </DashboardLayout>
  );
}
const auditOpinionOption = [
  { value: "Ý kiến trái ngược", label: "Ý kiến trái ngược" },
  { value: "Ý kiến từ chối đưa ra ý kiến", label: "Ý kiến từ chối đưa ra ý kiến" },
  { value: "Ý kiến ngoại trừ", label: "Ý kiến ngoại trừ" },
  { value: "Ý kiến chấp nhận toàn phần", label: "Ý kiến chấp nhận toàn phần" },
];
function Fields({ formData }) {
  const { formField, values, errors, touched } = formData;
  const {
    taxpayers,
    taxCode,
    taxAgentName,
    taxAgentCode,

    BCTC,
    supportData,
    enterVoiceover,
    auditOpinion,
  } = formField;
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Grid spacing={3} container>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxpayers.name}
            label={taxpayers.label}
            value={values.taxpayers}
            error={errors.taxpayers && touched.taxpayers}
            success={values.taxpayers?.toString().length > 0 && !errors.taxpayers}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxCode.name}
            label={taxCode.label}
            value={values.taxCode}
            error={errors.taxCode && touched.taxCode}
            success={values.taxCode?.toString().length > 0 && !errors.taxCode}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxAgentName.name}
            label={taxAgentName.label}
            value={values.taxAgentName}
            error={errors.taxAgentName && touched.taxAgentName}
            success={values.taxAgentName?.toString().length > 0 && !errors.taxAgentName}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxAgentCode.name}
            label={taxAgentCode.label}
            value={values.taxAgentCode}
            error={errors.taxAgentCode && touched.taxAgentCode}
            success={values.taxAgentCode?.toString().length > 0 && !errors.taxAgentCode}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <SwitchField name={BCTC.name} label={BCTC.label} value={values.BCTC} />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <SwitchField
            name={supportData.name}
            label={supportData.label}
            value={values.supportData}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <SwitchField
            name={enterVoiceover.name}
            label={enterVoiceover.label}
            value={values.enterVoiceover}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <SelectField
            options={auditOpinionOption}
            type={auditOpinion.type}
            label={auditOpinion.label}
            name={auditOpinion.name}
            value={values.auditOpinion}
            placeholder={auditOpinion.placeholder}
            error={errors.auditOpinion && touched.auditOpinion}
            success={values.auditOpinion.length > 0 && !errors.auditOpinion}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
